export default {"src":"/_next/static/media/celebChoice.77d0b387.gif","height":36,"width":36,"blurWidth":0,"blurHeight":0};